var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6667 9.33333C10.6667 7.91885 11.2286 6.56229 12.2288 5.5621C13.229 4.5619 14.5856 4 16.0001 4C17.4145 4 18.7711 4.5619 19.7713 5.5621C20.7715 6.56229 21.3334 7.91885 21.3334 9.33333C21.3334 10.7478 20.7715 12.1044 19.7713 13.1046C18.7711 14.1048 17.4145 14.6667 16.0001 14.6667C14.5856 14.6667 13.229 14.1048 12.2288 13.1046C11.2286 12.1044 10.6667 10.7478 10.6667 9.33333ZM10.6667 17.3333C8.89862 17.3333 7.20292 18.0357 5.95268 19.286C4.70244 20.5362 4.00006 22.2319 4.00006 24C4.00006 25.0609 4.42149 26.0783 5.17163 26.8284C5.92178 27.5786 6.93919 28 8.00006 28H24.0001C25.0609 28 26.0783 27.5786 26.8285 26.8284C27.5786 26.0783 28.0001 25.0609 28.0001 24C28.0001 22.2319 27.2977 20.5362 26.0474 19.286C24.7972 18.0357 23.1015 17.3333 21.3334 17.3333H10.6667Z",
    fill: "#00502E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/Profile.d18eac0f2fd7ff13469277fec0804f36.svg";
export { ForwardRef as ReactComponent };